import type { JSX } from "react";
import { useEffect } from "react";
import { useSceneStore } from "@/state/useSceneStore";

export const RoomLights = (): JSX.Element => {
  const theme = useSceneStore((s) => s.theme);
  const ambientIntensity = theme === "dark" ? 0.3 : 0.6;
  const pointIntensity = theme === "dark" ? 1.5 : 2.5;

  useEffect(() => {
    document.documentElement.classList.toggle("theme-light", theme === "light");
  }, [theme]);

  return (
    <>
      <ambientLight intensity={ambientIntensity} />
      <pointLight
        position={[0.3, 2, 0.5]}
        intensity={pointIntensity}
        distance={10}
        castShadow
        shadow-mapSize={[2048, 2048]}
        shadow-bias={-0.002}
      />
    </>
  );
};
